








import { Component, Vue, PropSync, Emit, Prop } from 'vue-property-decorator';
import OwnersDeleteModal from '../owners-delete-modal/OwnersDeleteModal.vue';
import * as ownerService from '@/services/owner/index';
import { Owner } from '@/api/owner/types';
import Loading from '@/components/loading/Loading.vue';

@Component({
  name: 'OwnersDeleteModalController',
  components: {
    OwnersDeleteModal,
    loading: Loading
  }
})
export default class OwnersDeleteModalController extends Vue {

  @Prop({ type: Boolean, default: false }) 
  private modal !: boolean;

  @Prop({ type: Owner, required: false }) 
  private owner !: Owner;

  private isLoading = false;

  private closeOwnerDelete() {
    this.$emit('oncancel');
    this.isLoading = false
  }

  @Emit("oncancel")
  private async ownerDelete(owner: Owner) {
    this.isLoading = true;
    await ownerService.deleteOwner(owner);
    this.isLoading = false
  }
}
